import styled from 'styled-components';

export const Button = styled.button`
  background: #626ed4;
  border: 0;
  padding: 10px 15px;
  border-radius: 4px;
  color: #fff;
`;
